const namespaced = true

import api from '../../api/userplants.js';
const state = {
    userPlants: [],
    userPlantsNot: [],
}
const mutations = {
    MUTATION_SET_USER_PLANTS(state, data) {
        state.userPlants = data.data;
    },
    MUTATION_SET_USER_PLANTS_NOT(state, data) {
        state.userPlantsNot = data;
    }
}
const actions = {
    getID(context, id) {
        return new Promise((resolve) => {
            api.getID(id).then(function (res) {
                context.commit('MUTATION_SET_USER_PLANTS', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });

            })
        })
    },
    getIDNot(context, id) {
        return new Promise((resolve) => {
            api.getIDNot(id).then(function (res) {
                context.commit('MUTATION_SET_USER_PLANTS_NOT', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });

            })
        })
    },
    store(context, data){
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    deleteUserPlant(context, id){
        return new Promise((resolve, reject) => {
            api.deleteUserPlant(id).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    updateManager(context, data){
        return new Promise((resolve, reject) => {
            api.updateManager(data).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    
}

const getters = {
    getPlants(state){
        return state.userPlants;
     },
     getPlantNot(state){
         return state.userPlantsNot;
     },
    
}
export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}